export const getCookieValue = (cookie) => {
    const cookiePrefix = `${cookie}=`;
    const allCookies = document.cookie.split(';');

    for (let i = 0; i < allCookies.length; i += 1) {
        const theCookie = String(allCookies[i]).trim();

        if (theCookie.indexOf(cookiePrefix) === 0) {
            return theCookie.substring(cookiePrefix.length, theCookie.length);
        }
    }

    return null;
};
